import { Path } from '@/main/router/routerPath';

import { KodyCV } from './kodyCV';
import { Logotypy } from './logotypy';
import { VyrobekNd } from './vyrobekNd';
import { VyrobekVoz } from './vyrobekVoz';

export const router = new Path('Koncernove').addChildren([
	VyrobekNd.router,
	VyrobekVoz.router,
	Logotypy.router,
	KodyCV.router,
]);
